import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ContainerMain } from './styles/components/container.styles';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ContainerMain className='container-main'>
    <App />
  </ContainerMain>
);